import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  BackgroundTask,
  BackgroundTaskService,
} from '@lmc-app/core/services/background-task.service';
import { LmcDialogComponent, LmcDialogData } from '@lmc-app/shared/components/dialog/lmc-dialog.component';

@Component({
  selector: 'app-background-task-indicator',
  templateUrl: './background-task-indicator.component.html',
  styleUrls: ['./background-task-indicator.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    MatTooltipModule,
  ],
  animations: [
    trigger('slideUp', [
      transition(':enter', [
        style({ transform: 'translateY(20px)', opacity: 0 }),
        animate('200ms ease-out', style({ transform: 'translateY(0)', opacity: 1 })),
      ]),
      transition(':leave', [
        animate('150ms ease-in', style({ transform: 'translateY(20px)', opacity: 0 })),
      ]),
    ]),
    trigger('collapseExpand', [
      state('collapsed', style({ height: '0px', overflow: 'hidden' })),
      state('expanded', style({ height: '*' })),
      transition('collapsed <=> expanded', animate('200ms ease-in-out')),
    ]),
  ],
})
export class BackgroundTaskIndicatorComponent {
  readonly tasks$ = this.backgroundTaskService.tasks$;

  readonly activeCount$ = this.backgroundTaskService.activeTasks$.pipe(
    map((tasks) => tasks.length)
  );

  isCollapsed = false;

  constructor(
    private readonly backgroundTaskService: BackgroundTaskService,
    private readonly dialog: MatDialog
  ) {}

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  cancel(task: BackgroundTask): void {
    const data: LmcDialogData = {
      title: 'Cancel Task',
      content: `Are you sure you want to cancel "${task.title}"?`,
      positiveButtonText: 'Yes',
      negativeButtonText: 'No',
    };

    this.dialog
      .open(LmcDialogComponent, { data, width: '360px', autoFocus: false })
      .afterClosed()
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.backgroundTaskService.cancelTask(task.id);
        }
      });
  }

  dismiss(taskId: string): void {
    this.backgroundTaskService.dismissTask(taskId);
  }

  getProgressPercent(task: BackgroundTask): number {
    if (!task.progressTotal) return 0;
    return Math.round((task.progressCurrent / task.progressTotal) * 100);
  }

  trackByTaskId(_index: number, task: BackgroundTask): string {
    return task.id;
  }
}